﻿import React from 'react'
import { Text } from '../ui'
import { normalizeLigacaoInformacoesLinhas } from '../../lib/ligacaoInformacoes'

interface LigacaoInformacoesListProps {
  /** Textos incrementais gravados no array `note_lines`. */
  lines: string[] | null | undefined
  /** Quando true, layout mais compacto (ex.: célula de tabela). */
  compact?: boolean
  className?: string
}

/**
 * Exibe as informações do contato como lista ordenada (1, 2, 3…),
 * alinhado ao modelo incremental gravado no banco.
 */
const LigacaoInformacoesList: React.FC<LigacaoInformacoesListProps> = ({ lines, compact, className }) => {
  const items = normalizeLigacaoInformacoesLinhas(lines)

  if (items.length === 0) {
    return (
      <Text size="sm" color="muted" className={className}>
        -
      </Text>
    )
  }

  return (
    <ol className={`list-none space-y-2 ${className ?? ''}`}>
      {items.map((text, idx) => (
        <li
          key={`${idx}-${text.slice(0, 24)}`}
          className={`flex gap-3 rounded-lg border border-gray-200 bg-gray-50/80 dark:border-gray-600 dark:bg-gray-800/40 ${
            compact ? 'px-2 py-1.5' : 'px-3 py-2'
          }`}
        >
          <span
            className={`flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-md bg-primary-100 text-xs font-semibold text-primary-800 dark:bg-primary-900/40 dark:text-primary-200 ${
              compact ? 'h-6 w-6 text-[10px]' : ''
            }`}
            title={`Informação ${idx + 1}`}
          >
            {idx + 1}
          </span>
          <Text size="sm" className="min-w-0 flex-1 whitespace-pre-wrap break-words">
            {text}
          </Text>
        </li>
      ))}
    </ol>
  )
}

export default LigacaoInformacoesList
